import React from "react";
import styles from "./styles/SecondHeader.module.css";
import { Link, useNavigate } from "react-router-dom";
import { AvatarPopup } from "@components";
import { ReactComponent as Logo } from "@assets/svgs/logo.svg";
import { Button, Container, Stack } from "react-bootstrap";
import { useSelector } from "react-redux";

const SecondHeader = () => {
  // state

  // variables

  // logics before hooks

  // hooks
  const navigate = useNavigate();
  const { login } = useSelector((state) => state.auth);
  const { isAuth } = login;

  // logics
  const handleReturn = () => navigate(-1);

  // UI partials

  // effects

  // render
  return (
    <header className={styles.header}>
      <Container className="d-flex justify-content-between align-items-center">
        <Button
          style={{ borderRadius: "30px" }}
          variant="outline-primary"
          onClick={handleReturn}
        >
          <i className="bi bi-arrow-left-short mr-2" />
          Back
        </Button>
        {isAuth ? (
          <AvatarPopup />
        ) : (
          <Stack direction="horizontal" gap={2} className="mr-3">
            <Button onClick={() => navigate("/sign-in")}>Sign In</Button>
            <Button
              variant="outline-primary"
              onClick={() => navigate("/sign-up")}
            >
              Sign Up
            </Button>
          </Stack>
        )}
      </Container>
      <Link to={"/"} className={styles.logo}>
        <Logo width={120} />
      </Link>
    </header>
  );
};
/* required: display name */
SecondHeader.displayName = "SecondLayout";

/* required: props types */
SecondHeader.propTypes = {};

/* required: default props */
SecondHeader.defaultProps = {};
export { SecondHeader };
